/* =========================================================================
   pr-edit.js (owner: home). sections/pr-edit.liquid "The Edit" lineup. Loaded by the section, after the shared PR scripts.
     Desktop (fine pointer, >= 900px): pointing at a model sets her --f to 1, so she turns to the front photo and her slot
       widens. The model is picked from the resting layout, not from what is under the pointer: the turned model stays
       centred on her resting slot, so moving across the lineup never flickers.
     Touch: the rail scrolls; each model's --f comes from her distance to the middle, so the one in front faces you.
     Click / tap the one in front: the focus view (moved to <body>) opens with a FLIP from her photo, Front / Side / Back,
       the photographed colour's sizes and Add to bag (PR.bag.add, which opens the bag drawer above this view).
   ========================================================================= */
(function () {
  'use strict';
  var w = window, d = document;
  var PR = w.PR;
  if (!PR || !PR.sections) return;

  var HOVER_MQ = '(hover: hover) and (pointer: fine) and (min-width: 900px)';
  var $ = function (s, el) { return (el || d).querySelector(s); };
  var $$ = function (s, el) { return Array.prototype.slice.call((el || d).querySelectorAll(s)); };
  var esc = PR.esc;
  function reduced() { return PR.reduced ? PR.reduced() : false; }
  function money(p) { return PR.money ? PR.money(p) : String(p / 100); }
  function sizeLabel(s) { return PR.size && PR.size.norm ? PR.size.norm(s) : s; }
  function colourLabel(c) { return PR.colour && PR.colour.label ? PR.colour.label(c) : c; }
  function lowStock() { return (PR.cfg && PR.cfg.lowStock) || 3; }

  function init(el) {
    var rail = $('[data-pr-edit-rail]', el);
    var dataEl = $('[data-pr-edit-data]', el);
    var focus = $('[data-pr-edit-focus]', el);
    if (!rail || !dataEl || !focus) return;
    var P = [];
    try { P = JSON.parse(dataEl.textContent) || []; } catch (e) { P = []; }
    var items = $$('.pr-edit__look', rail);
    if (!P.length || items.length !== P.length) return;

    // The tiles use transforms and isolation; a fixed overlay inside them would be trapped under the nav.
    d.body.appendChild(focus);
    var stage = $('[data-pr-edit-stage]', focus), info = $('[data-pr-edit-info]', focus);
    var sizesEl = $('[data-pr-edit-sizes]', focus), cta = $('[data-pr-edit-cta]', focus), more = $('[data-pr-edit-more]', focus);
    var viewsEl = $('[data-pr-edit-views]', focus), stockEl = $('[data-pr-edit-stock]', focus);
    var vImg = { front: $('[data-v="front"]', stage), side: $('[data-v="side"]', stage), back: $('[data-v="back"]', stage) };
    var cap = $('[data-pr-edit-cap]', el);
    var mq = w.matchMedia(HOVER_MQ);
    var mid = (P.length - 1) / 2;
    var st = { mode: '', active: -1, centre: 0, open: -1, size: null, busy: false, ticking: false, lastFocus: null, sx: null };

    function caption(i, x) {
      if (!cap) return;
      if (i < 0) { cap.classList.remove('is-on'); return; }
      cap.firstChild.textContent = P[i].name;
      cap.lastChild.textContent = money(P[i].price);
      cap.style.setProperty('--x', x + 'px');
      cap.classList.add('is-on');
    }

    /* ---------- desktop ---------- */
    function restSlots() {
      var slot = items[0].offsetHeight * (parseFloat(getComputedStyle(el).getPropertyValue('--narrow')) || .28);
      return { slot: slot, start: rail.clientWidth / 2 - slot * P.length / 2 };
    }
    function setActive(i) {
      if (i === st.active) return;
      st.active = i;
      items.forEach(function (li, k) {
        li.style.setProperty('--f', k === i ? 1 : 0);
        li.style.zIndex = i < 0 ? 20 - Math.round(Math.abs(k - mid) * 2) : (k === i ? 40 : 30 - Math.abs(k - i));
      });
      var r = restSlots();
      caption(i, r.start + (i + 0.5) * r.slot);
    }
    function indexAt(x) {
      var r = restSlots();
      var i = Math.floor((x - rail.getBoundingClientRect().left - r.start) / r.slot);
      return i >= 0 && i < P.length ? i : -1;
    }
    function onMove(e) { if (st.mode === 'hover' && st.open < 0 && e.pointerType === 'mouse') setActive(indexAt(e.clientX)); }
    function onLeave() { if (st.mode === 'hover' && st.open < 0) setActive(-1); }

    /* ---------- touch ---------- */
    function updateSwipe() {
      st.ticking = false;
      var r = rail.getBoundingClientRect(), c = r.left + r.width / 2, best = 0, bd = Infinity;
      items.forEach(function (li, k) {
        var b = li.getBoundingClientRect();
        var dd = (b.left + b.width / 2 - c) / b.width, f = Math.max(0, 1 - Math.abs(dd));
        li.style.setProperty('--f', f.toFixed(3));
        li.style.zIndex = 10 + Math.round(f * 30);
        if (Math.abs(dd) < bd) { bd = Math.abs(dd); best = k; }
      });
      st.centre = best;
      caption(best, rail.clientWidth / 2);
    }
    function onScroll() { if (st.mode === 'swipe' && !st.ticking) { st.ticking = true; w.requestAnimationFrame(updateSwipe); } }
    // scrollLeft target from layout widths, not offsetLeft (the rail is not the items' offsetParent)
    function centreOn(i, smooth) {
      var slot = items[0].offsetWidth, pad = parseFloat(getComputedStyle(rail).paddingLeft) || 0;
      var left = pad + slot * i + slot / 2 - rail.clientWidth / 2;
      rail.scrollTo({ left: left, behavior: smooth && !reduced() ? 'smooth' : 'auto' });
    }

    function setMode() {
      var m = mq.matches ? 'hover' : 'swipe';
      if (m === st.mode) return;
      st.mode = m;
      el.setAttribute('data-mode', m);
      items.forEach(function (li) { li.style.removeProperty('--f'); li.style.zIndex = ''; });
      if (m === 'hover') { st.active = -2; setActive(-1); }
      else { centreOn(Math.min(1, P.length - 1), false); updateSwipe(); }   // start with a model on each side
    }
    function onResize() { if (st.mode === 'swipe') updateSwipe(); else { var a = st.active; st.active = -2; setActive(a); } }

    function onRailClick(e) {
      var btn = e.target.closest('.pr-edit__btn'); if (!btn) return;
      var i = +btn.getAttribute('data-i');
      if (st.mode === 'hover') openFocus(st.active >= 0 ? st.active : i);
      else if (i === st.centre) openFocus(i);
      else centreOn(i, true);
    }
    function onRailFocus(e) {
      var btn = e.target.closest('.pr-edit__btn'); if (!btn || st.open >= 0) return;
      var i = +btn.getAttribute('data-i');
      if (st.mode === 'hover') setActive(i); else centreOn(i, true);
    }

    /* ---------- focus view ---------- */
    function setView(v) {
      stage.setAttribute('data-view', v);
      $$('button', viewsEl).forEach(function (b) { b.setAttribute('aria-checked', String(b.getAttribute('data-view') === v)); });
    }
    function setSize(s) {
      var p = P[st.open];
      st.size = s;
      $$('button', sizesEl).forEach(function (b) { b.setAttribute('aria-checked', String(!!s && String(s.id) === b.getAttribute('data-id'))); });
      var anyAvail = p.sizes.some(function (x) { return x.a; });
      cta.disabled = !s;
      cta.textContent = s ? cta.getAttribute('data-label-add') + ' · ' + money(s.p) : (anyAvail ? cta.getAttribute('data-label-pick') : cta.getAttribute('data-label-sold'));
      stockEl.textContent = s && s.q > 0 && s.q <= lowStock() ? 'Only ' + s.q + ' left in ' + sizeLabel(s.s) : '';
      $('[data-pr-edit-price]', focus).textContent = money(s ? s.p : p.price);
      more.href = p.url + (s ? (p.url.indexOf('?') > -1 ? '&' : '?') + 'variant=' + s.id : '');
    }
    function render(i) {
      var p = P[i];
      ['front', 'side', 'back'].forEach(function (v) {
        var im = p.img[v], node = vImg[v];
        if (im) { node.srcset = im.srcset; node.src = im.src; node.alt = im.alt || (p.name + (p.colour ? ', ' + colourLabel(p.colour) : '') + ', ' + v); }
        else { node.removeAttribute('srcset'); node.removeAttribute('src'); node.alt = ''; }
      });
      $('[data-pr-edit-title]', focus).textContent = p.name;
      $('[data-pr-edit-meta]', focus).textContent = [p.colour ? colourLabel(p.colour) : '', p.line || ''].filter(Boolean).join(' · ');
      $('[data-view="back"]', viewsEl).hidden = !p.img.back;
      $('[data-view="side"]', viewsEl).hidden = !p.img.side;
      sizesEl.innerHTML = p.sizes.map(function (s) {
        var label = sizeLabel(s.s);
        return '<button type="button" role="radio" aria-checked="false" data-id="' + s.id + '"' +
          (s.a ? '' : ' disabled aria-label="' + esc(label) + ', sold out"') + '>' + esc(label) + '</button>';
      }).join('');
      setView('front');
      setSize(null);
    }
    function srcImg(i) { return $('.pr-edit__front', items[i]); }
    function fig(i) { return $('.pr-edit__fig', items[i]); }
    function flip(node, from, to, reverse) {
      if (reduced() || !node.animate || !to.width || !to.height) return Promise.resolve();
      var t = 'translate(' + (from.left - to.left) + 'px,' + (from.top - to.top) + 'px) scale(' + (from.width / to.width) + ',' + (from.height / to.height) + ')';
      var frames = reverse ? [{ transform: 'none' }, { transform: t }] : [{ transform: t }, { transform: 'none' }];
      var a = node.animate(frames, { duration: reverse ? 460 : 620, easing: 'cubic-bezier(.2,.8,.2,1)', fill: reverse ? 'forwards' : 'none' });
      return a.finished.catch(function () {});
    }
    function lock(on) { d.body.classList.toggle('ap-lock', on); }

    function openFocus(i) {
      if (st.open >= 0 || !P[i]) return;
      if (PR.closeChrome) PR.closeChrome();
      st.open = i; st.lastFocus = d.activeElement;
      if (st.mode === 'hover') setActive(i);
      render(i);
      focus.hidden = false;
      lock(true);
      var from = srcImg(i).getBoundingClientRect(), to = vImg.front.getBoundingClientRect(), f = fig(i);
      f.style.visibility = 'hidden';
      w.requestAnimationFrame(function () { focus.classList.add('is-on'); });
      flip(vImg.front, from, to).then(function () { f.style.visibility = ''; });
      $('[data-pr-edit-close]', focus).focus({ preventScroll: true });
    }
    function closeFocus(instant) {
      if (st.open < 0) return;
      var i = st.open, f = fig(i);
      var done = function () {
        f.style.visibility = '';
        focus.hidden = true;
        focus.classList.remove('is-on');
        vImg.front.getAnimations && vImg.front.getAnimations().forEach(function (a) { a.cancel(); });
        st.open = -1;
        if (!$('dialog[open]') && !$('.ap-bag.is-open')) lock(false);
        if (st.mode === 'hover') { st.active = -2; setActive(-1); }
        var lf = st.lastFocus; st.lastFocus = null;
        if (!instant && lf && lf.focus && el.contains(lf)) { try { lf.focus({ preventScroll: true }); } catch (e) {} }
      };
      setView('front');
      if (instant) return done();
      var from = srcImg(i).getBoundingClientRect(), to = vImg.front.getBoundingClientRect();
      f.style.visibility = 'hidden';
      focus.classList.remove('is-on');
      flip(vImg.front, from, to, true).then(done);
    }
    function step(dir) {
      if (st.open < 0 || P.length < 2) return;
      var next = (st.open + dir + P.length) % P.length, parts = [stage, info];
      parts.forEach(function (x) { x.style.setProperty('--dx', (-dir * 24) + 'px'); x.classList.add('is-swap'); });
      setTimeout(function () {
        st.open = next;
        render(next);
        if (st.mode === 'hover') setActive(next); else { centreOn(next, false); updateSwipe(); }
        parts.forEach(function (x) { x.style.setProperty('--dx', (dir * 24) + 'px'); });
        w.requestAnimationFrame(function () { parts.forEach(function (x) { x.classList.remove('is-swap'); }); });
      }, reduced() ? 0 : 180);
    }

    function onFocusClick(e) {
      var t = e.target;
      if (t === focus || t.classList.contains('pr-edit-focus__sheet')) return closeFocus();
      if (t.closest('[data-pr-edit-close]')) return closeFocus();
      var stp = t.closest('[data-pr-edit-step]'); if (stp) return step(+stp.getAttribute('data-pr-edit-step'));
      var vb = t.closest('[data-pr-edit-views] button'); if (vb) return setView(vb.getAttribute('data-view'));
      var sb = t.closest('[data-pr-edit-sizes] button');
      if (sb && !sb.disabled) { var id = sb.getAttribute('data-id'); return setSize(P[st.open].sizes.filter(function (x) { return String(x.id) === id; })[0] || null); }
      if (t.closest('[data-pr-edit-cta]')) return add();
    }
    function add() {
      if (!st.size || st.busy || !PR.bag || !PR.bag.add) return;
      st.busy = true; cta.classList.add('is-busy'); cta.setAttribute('aria-busy', 'true');
      PR.bag.add({ id: st.size.id, quantity: 1 }).then(function () {
        closeFocus(true);   // the bag drawer is open on top now; closing it lands back on the lineup
      }, function () {}).then(function () {
        st.busy = false; cta.classList.remove('is-busy'); cta.removeAttribute('aria-busy');
      });
    }
    function onKey(e) {
      if (st.open < 0 || ($('.ap-bag.is-open'))) return;
      if (e.key === 'Escape') { e.preventDefault(); closeFocus(); }
      else if (e.key === 'ArrowRight' && !e.target.closest('[role="radiogroup"]')) step(1);
      else if (e.key === 'ArrowLeft' && !e.target.closest('[role="radiogroup"]')) step(-1);
      else if (e.key === 'Tab') {
        var f = $$('button:not(:disabled):not([hidden]), a[href]', focus).filter(function (x) { return x.offsetParent !== null; });
        if (!f.length) return;
        var first = f[0], last = f[f.length - 1];
        if (e.shiftKey && d.activeElement === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && d.activeElement === last) { e.preventDefault(); first.focus(); }
      }
    }
    // swipe left / right on the big photo to change product
    function onDown(e) { st.sx = e.clientX; }
    function onUp(e) { if (st.sx !== null && Math.abs(e.clientX - st.sx) > 50) step(e.clientX < st.sx ? 1 : -1); st.sx = null; }

    // Theme editor: selecting a look turns her to the front
    function onBlockSelect(e) {
      var li = e.target && e.target.closest ? e.target.closest('.pr-edit__look') : null;
      if (!li || !el.contains(li)) return;
      var i = +li.getAttribute('data-i');
      if (st.mode === 'hover') setActive(i); else centreOn(i, true);
    }

    rail.addEventListener('pointermove', onMove);
    rail.addEventListener('pointerleave', onLeave);
    rail.addEventListener('scroll', onScroll, { passive: true });
    rail.addEventListener('click', onRailClick);
    rail.addEventListener('focusin', onRailFocus);
    focus.addEventListener('click', onFocusClick);
    stage.addEventListener('pointerdown', onDown);
    stage.addEventListener('pointerup', onUp);
    d.addEventListener('keydown', onKey);
    d.addEventListener('shopify:block:select', onBlockSelect);
    w.addEventListener('resize', onResize);
    if (mq.addEventListener) mq.addEventListener('change', setMode); else if (mq.addListener) mq.addListener(setMode);
    setMode();
    // warm the back and side views so Front / Side / Back switch instantly
    var warm = function () { P.forEach(function (p) { ['back', 'side'].forEach(function (v) { if (p.img[v]) { var im = new Image(); im.sizes = 'min(490px, 90vw)'; im.srcset = p.img[v].srcset; } }); }); };
    if ('requestIdleCallback' in w) w.requestIdleCallback(warm, { timeout: 4000 }); else setTimeout(warm, 2500);

    el._prEdit = function () {
      closeFocus(true);
      rail.removeEventListener('pointermove', onMove);
      rail.removeEventListener('pointerleave', onLeave);
      rail.removeEventListener('scroll', onScroll);
      rail.removeEventListener('click', onRailClick);
      rail.removeEventListener('focusin', onRailFocus);
      d.removeEventListener('keydown', onKey);
      d.removeEventListener('shopify:block:select', onBlockSelect);
      w.removeEventListener('resize', onResize);
      if (mq.removeEventListener) mq.removeEventListener('change', setMode); else if (mq.removeListener) mq.removeListener(setMode);
      if (focus.parentNode) focus.parentNode.removeChild(focus);
    };
  }

  function destroy(el) { if (el._prEdit) { el._prEdit(); el._prEdit = null; } }

  PR.sections.register('pr-edit', init, destroy);
})();
